import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=0dab7960&scoped=true&"
import script from "./MenuContainer.vue?vue&type=script&lang=js&"
export * from "./MenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./MenuContainer.vue?vue&type=style&index=0&id=0dab7960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab7960",
  null
  
)

export default component.exports